import Typography from "typography";
import 'typeface-open-sans';

const typography = new Typography({
  baseFontSize: "18px",
  baseLineHeight: 1.45,
  headerFontFamily: [
    "Open Sans",
    "sans-serif",
  ],
  blockMarginBottom: 0.5,
  bodyFontFamily: ["Georgia", "serif"],
});

export default typography;



// WEBPACK FOOTER //
// ./src/utils/typography.js